import { OnInit } from '@angular/core';
var MasterdataComponent = /** @class */ (function () {
    function MasterdataComponent() {
    }
    MasterdataComponent.prototype.ngOnInit = function () {
    };
    return MasterdataComponent;
}());
export { MasterdataComponent };
